import React, { Component } from 'react';
import { Route, Switch, withRouter, matchPath } from 'react-router-dom';
import { getRoutes, protectedRoutes, routes } from '../../routes';
import './Base.css';
import Header from '../../components/header/Header';
import LeftMenu from '../../components/leftmenu/LeftMenu';
import IdleTimer from 'react-idle-timer';

// Redux
import withShipment from '../../withShipment';
import {
  userInfoSelector,
  isAuthenticatedSelector,
  employeesSelector,
} from '../../redux/selectors/auth';
import {
  authLogout,
  getEmployees,
  getUsers,
  refreshUserInfo,
  updateUserInfo,
} from '../../redux/actions/auth';
import { ROUTE_TYPE } from '../../routes/constants';
import Login from '../Login/Login';
import { showingMenuItemsSelector } from '../../redux/selectors/global';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import {
  setBlacklistAlert,
  triggerRefresh,
  listAvailableCompanies,
  uploadBonusPhoto,
} from '../../redux/actions/settings';
import { listPendingPhotos } from '../../components/bonus/photoOutbox';
import { processRFID, registerRFID } from '../../redux/actions/userManagement';
import ClockInOut from '../../components/clockinout/ClockInOut';
import { Redirect } from 'react-router';
import PageNotFound from '../../routes/PageNotFound';
import CheckIn404 from '../../routes/CheckIn404';
import LandingPage from '../../components/landing/LandingPage';
import Seo from '../../components/global/Seo';
import { ROLE_ADMIN } from '../../components/global/constants';
import {
  cleanLayoutPaths,
  ROLE_MASTER_ADMIN,
  ROLE_TECH_ADMIN,
} from '../../components/settings/ManageUsers/constants';
import AuthUtil from '../../redux/AuthUtil';
import Utils from '../../components/Utils/Utils';
import Footer from '../../components/footer/Footer';
import LockedShell from '../Locked/LockedShell';
import { isRouteHiddenForUser } from '../../constants/roleMenuVisibility';
import { allowedRoutes, isClockedOut } from '../../constants/clockInAccess';
import ReadOnlyToast from '../../components/global/ReadOnly/ReadOnlyToast';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Typography,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Alert from '@material-ui/lab/Alert';
import { blacklistAlertSelector } from '../../redux/selectors/ticketOut';
import { Grid } from '@mui/material';
import { BASE_URL } from '../../components/global/Server/endpoints';
import {
  detectFace,
  loadFaceModels,
} from '../../components/Utils/faceDetection';
import { createCaptureQueue } from '../../components/Utils/captureQueue';
import { fetchAlerts } from '../../redux/actions/alerts';
import { ensurePlanCatalog } from '../../components/settings/ManageCompany/planCatalogRuntime';

// react-idle-timer's default event list, minus 'visibilitychange'. Tab and
// app switches are handled explicitly in handleIdleVisibility (pause/resume)
// so leaving the app never counts as idle time, and coming back never trips
// the library's "overdue" check straight into a logout.
const IDLE_ACTIVITY_EVENTS = [
  'mousemove',
  'keydown',
  'wheel',
  'DOMMouseScroll',
  'mousewheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
  'MSPointerMove',
];

// Auto-logout after an hour with the app on screen and untouched. Time spent
// in another app or tab is paused, not counted.
const IDLE_TIMEOUT_MS = 60 * 60 * 1000;

// Hard ceiling on top of that pausing: a session that has seen no real
// interaction for 8 hours is over no matter how much of that time was spent
// in the background. Checked when the app comes back to the foreground —
// the only moment a session parked in another app matters again.
const IDLE_HARD_CEILING_MS = 8 * 60 * 60 * 1000;

// How often to re-probe /health/ping once the backend has been marked
// DOWN. While the app is broken nothing else is in flight, so without a
// poll the banner would sit there red until an employee happened to
// click something — which is how a 30-second restart looks like a
// half-hour outage.
const HEALTH_POLL_MS = 10 * 1000;

// Grace period between "the backend is answering again" and the reload.
// Long enough that the green banner is readable — an employee who watched
// the page break deserves to see it heal rather than have it blink — and
// short enough that nobody starts typing into a screen that is about to
// go away.
const RECOVERY_RELOAD_DELAY_MS = 3000;

// A reload that lands back in the outage would reload again on the next
// recovery, and a deploy that flaps would turn that into a loop nobody
// can click out of. Cap it at one automatic reload per minute; after
// that the banner still clears and the user refreshes when they like.
// sessionStorage because the timestamp has to survive the reload itself.
const RECOVERY_RELOAD_COOLDOWN_MS = 60 * 1000;
const RECOVERY_RELOAD_KEY = 'nds:lastOutageReloadAt';

class Base extends Component {
  constructor(props) {
    super(props);
    const isIOSSafari = /iP(ad|hone|od).*Safari/i.test(navigator.userAgent);
    this.state = {
      isMobile:
        window.matchMedia('(max-width: 800px)').matches ||
        isIOSSafari ||
        Utils.isMobileDevice(),
      messages: [],
      rfid: '',
      triggerUpdate: false,
      announcementMessage: '',
      announcementEnd: '',
      serverStatus: '',
      showProfile: false,
      showSelfRegister: false,
      tempRfid: '', // To store the rfid while we choose a user
      selectedEmployeeId: '',
      feedbackOpen: false,
      feedbackMessage: '',
      feedbackSeverity: 'success', // 'success' | 'error'
      isSubmitting: false, // To show a loading spinner on the button

      //alert
      isImageZoomed: false,
    };

    // Ref for the (hidden) webcam video element. Captures snapshot into
    // per-capture private canvases — see captureImage.
    this.videoRef = React.createRef();
    this.inputRef = React.createRef();
    // The app shell div that holds the banner stack, the sticky nav and
    // the page content. Observed for size changes so --nds-banner-offset
    // is re-measured whenever a banner appears, disappears or rewraps.
    // NOT a wrapper around the banners themselves: the sticky nav's
    // containing block is this div, and boxing the nav in a tighter
    // parent would leave it no room to stick. See syncLayoutRails.
    this.shellRef = React.createRef();
    this.railsObserver = null;
    this.railsFrame = null;
    this.scrollBox = null;
    this.lastRails = {};
    // Runs capture jobs (face detection + upload) strictly one at a time so
    // back-to-back kiosk enrollments can't interleave.
    this.enqueueCapture = createCaptureQueue(this.processCapture);
    this.buffer = '';
    this.timer = null;
    this.idleTimer = null;
    this.idlePaused = false;
    this.lastActivityAt = Date.now();
    this.wakeLock = null;

    // The live WebSockets.
    //
    // Instance fields, NOT state: nothing renders from them, and the
    // guards in initConnections read them synchronously. They used to be
    // written with setState while initConnections tested `this.socket` /
    // `this.socketRfid` — fields nothing ever assigned — so every guard
    // passed, initConnections re-ran on every navigation, and a route
    // change landing while a socket was down could open a second socket
    // alongside the already-pending reconnect. Assigning here,
    // synchronously, is what makes those guards mean anything.
    this.socket = null;
    this.socketRfid = null;
  }

  // ---------------------------------------------------------------------
  // Banner offset  →  --nds-banner-offset
  //
  // Six bars can sit above the page content, all in normal document flow:
  // the payment-setup banner (rendered below), then inside Header the
  // tech-admin Maintenance Access banner, the My Account / company bar,
  // one of the outage / back-online / announcement banners, and finally
  // the sticky nav. Their combined height is nowhere near constant —
  // several can show at once, each wraps to two or three rows on a long
  // message or a narrow screen, and most switch to a taller stacked
  // layout on mobile. Measured range is roughly 76px (nav only) to 370px.
  //
  // Top-anchored Snackbars are position:fixed, so they know none of that.
  // FeedbackBar.css used to hard-code `top: 160px` (136px on mobile),
  // which is correct for exactly one combination and hides the toast
  // behind the stack for the rest. That was the bug.
  //
  // We measure the NAV rather than summing the banners, because the nav
  // is both the last bar in the stack and the only sticky one, so its
  // bottom edge is exactly the safe line in every scroll state:
  //   - scrolled to top   → nav bottom == full stack height
  //   - scrolled down     → banners have scrolled away, nav is pinned at
  //                         top:0, and its bottom is back down to ~76px
  // A height-based measure would get the second case wrong and strand the
  // toast 300px down the page. Note the app scrolls inside
  // .shipment-background, not the window, so that is what we listen to.
  syncLayoutRails = () => {
    const nav = document.querySelector('nav.top-nav');
    const offset = nav
      ? Math.max(0, Math.round(nav.getBoundingClientRect().bottom))
      : 0;
    // Writing a custom property on :root invalidates style for the whole
    // document, and this runs on scroll — only write on a real change.
    if (offset === this.lastRails.bannerOffset) return;
    this.lastRails = { bannerOffset: offset };
    document.documentElement.style.setProperty(
      '--nds-banner-offset',
      `${offset}px`
    );
  };

  // Scroll fires far more often than we need to re-measure; coalesce to
  // one read per frame so we never force layout mid-scroll.
  scheduleLayoutRailsSync = () => {
    if (this.railsFrame) return;
    this.railsFrame = window.requestAnimationFrame(() => {
      this.railsFrame = null;
      this.syncLayoutRails();
    });
  };

  componentDidMount() {
    // Re-read the account on every load. Nothing else did, so a session
    // restored from redux-persist kept whatever location list it was
    // logged in with — which is how a user whose access to a linked
    // location had been REVOKED could refresh the page and still be
    // sitting in that location, because their own browser was the only
    // thing that still believed they belonged there. This also keeps
    // routes, accessMode and lockState honest across a reload.
    if (this.props.isAuthenticated) this.props.refreshUserInfo();

    // The live rate card. It decides what each plan includes — which
    // Weekly Report tabs open, whether the Black List is there, which
    // permissions the Employee wizard may grant — so it has to be in place
    // before those screens render. Silent on failure: the shipped defaults
    // are already loaded, so the app degrades to them rather than breaking.
    ensurePlanCatalog();

    // Publish the offset before anything can raise a toast, then keep it
    // current. Three signals, because the nav's position moves for three
    // different reasons:
    //   ResizeObserver → a banner appeared / disappeared or rewrapped
    //                    without Base re-rendering (Header owns the
    //                    Maintenance Access and My Account bars off its
    //                    own props/state)
    //   scroll         → banners scrolling away under the sticky nav
    //   resize         → breakpoint flip into the taller mobile layouts
    this.syncLayoutRails();
    if (typeof ResizeObserver !== 'undefined' && this.shellRef.current) {
      this.railsObserver = new ResizeObserver(this.scheduleLayoutRailsSync);
      this.railsObserver.observe(this.shellRef.current);
    }
    this.scrollBox = document.querySelector('.shipment-background');
    if (this.scrollBox) {
      this.scrollBox.addEventListener('scroll', this.scheduleLayoutRailsSync, {
        passive: true,
      });
    }
    window.addEventListener('resize', this.scheduleLayoutRailsSync);

    this.mediaQuery = window.matchMedia('(max-width: 800px)');
    this.mediaQuery.addEventListener('change', this.handleScreenChange);
    this.requestWakeLock();

    // Fallback path for sessions without an active WebSocket (typically
    // ROLE_ADMIN dashboards, where initConnections short-circuits). When
    // AuthUtil sees an HTTP 423 from a feature endpoint, it dispatches
    // this event so we can flip into LockedShell without forcing a
    // re-login. Optimistic update + authoritative refresh keeps the
    // transition snappy while staying canonical.
    window.addEventListener('app:locked', this.handleAppLockedEvent);

    // Outage banner. AuthUtil raises these off plain HTTP failures, which
    // is the only signal that reaches EVERY role: the RFID WebSocket that
    // used to be the sole source of serverStatus is never opened for
    // admins, tech admins, reading users, or anyone without a selected
    // location, so those employees never saw the banner at all.
    window.addEventListener('app:server-down', this.handleServerDownEvent);
    window.addEventListener('app:server-up', this.handleServerUpEvent);

    // A shift-bound write was refused because the employee is clocked out.
    // Reached here from a STALE page: a second tab, or a phone that was in
    // the background when the shift ended. Pull their routes back in step
    // and put them on the clock-in screen.
    window.addEventListener('app:shift-closed', this.handleShiftClosedEvent);

    this.initConnections();

    // Bonus photos that never finished uploading (app closed / offline
    // mid-upload) wait in the on-device outbox. Drain it as soon as the
    // logged-in shell mounts — whatever screen the employee lands on —
    // and again whenever the connection comes back.
    this.drainPhotoOutbox();
    window.addEventListener('online', this.drainPhotoOutbox);

    // Inactivity logout only counts time the app is actually on screen.
    // Registered here rather than in initConnections because that method
    // early-returns for admins and reading users — exactly the roles
    // handleOnIdle logs out.
    document.addEventListener('visibilitychange', this.handleIdleVisibility);
  }

  componentDidUpdate(prevProps, prevState) {
    // Cheap (one rect read, early-returns when unchanged) and it catches
    // the cases ResizeObserver can't: the whole shell unmounting into
    // LockedShell, logging out, or switching to a clean-layout route —
    // all of which remove the nav and must drop the offset back to 0.
    this.syncLayoutRails();

    // Logout
    if (prevProps.isAuthenticated && !this.props.isAuthenticated) {
      this.cleanupConnections();
      return;
    }

    const authChanged =
      !prevProps.isAuthenticated && this.props.isAuthenticated;

    const locationChanged =
      prevProps.userInfo?.selectedLocationId !==
      this.props.userInfo?.selectedLocationId;

    const mobileChanged = prevState.isMobile !== this.state.isMobile;

    const pathChanged =
      prevProps.location.pathname !== this.props.location.pathname;

    if (authChanged || locationChanged || mobileChanged || pathChanged) {
      this.initConnections();
    }

    // Just logged in (uploads need a token), or the viewport just crossed
    // into the mobile breakpoint where the drain gate opens.
    if (authChanged || (mobileChanged && this.state.isMobile)) {
      this.drainPhotoOutbox();
    }
  }

  // Re-queue bonus photos persisted by components/bonus/photoOutbox.js.
  // The upload queue saga dedupes, so calling this repeatedly is safe.
  //
  // Gated to mobile + bonus-taking users: photos are only ever captured
  // in the mobile add-bonus camera flow by users holding the 'bonus'
  // route (Employee/Supervisor presets), so owners/managers on desktop
  // never touch the outbox.
  drainPhotoOutbox = async () => {
    if (!this.props.isAuthenticated || !this.state.isMobile) return;
    const routes = [...(this.props.userInfo?.routes || [])];
    if (!routes.includes('bonus')) return;
    const pending = await listPendingPhotos();
    pending.forEach((photo) => this.props.uploadBonusPhoto(photo));
  };

  componentWillUnmount() {
    this._isUnmounting = true;

    if (this.railsObserver) {
      this.railsObserver.disconnect();
      this.railsObserver = null;
    }
    if (this.railsFrame) {
      window.cancelAnimationFrame(this.railsFrame);
      this.railsFrame = null;
    }
    if (this.scrollBox) {
      this.scrollBox.removeEventListener(
        'scroll',
        this.scheduleLayoutRailsSync
      );
      this.scrollBox = null;
    }
    window.removeEventListener('resize', this.scheduleLayoutRailsSync);
    document.documentElement.style.removeProperty('--nds-banner-offset');

    this.cleanupConnections();

    if (this.wakeLock) {
      this.wakeLock.release();
      this.wakeLock = null;
    }

    this.mediaQuery.removeEventListener('change', this.handleScreenChange);
    window.removeEventListener('app:locked', this.handleAppLockedEvent);
    window.removeEventListener('app:server-down', this.handleServerDownEvent);
    window.removeEventListener('app:server-up', this.handleServerUpEvent);
    window.removeEventListener('app:shift-closed', this.handleShiftClosedEvent);
    this.stopHealthPolling();
    clearTimeout(this._reloadTimeout);
    window.removeEventListener('online', this.drainPhotoOutbox);
    document.removeEventListener('visibilitychange', this.handleIdleVisibility);
  }

  // HTTP-sourced outage signal. AuthUtil has already confirmed the
  // outage with a /health/ping probe before emitting, so we can trust
  // this without a second opinion.
  handleServerDownEvent = () => {
    // Recorded on the instance rather than read back off state at recovery
    // time: the RFID socket's onopen sets serverStatus 'UP' immediately
    // before AuthUtil emits 'app:server-up', so a state-based check would
    // find the DOWN already gone and never reload.
    this._sawServerDown = true;

    // A recovery reload scheduled seconds ago is pointless now — the
    // backend went away again before it fired, and reloading into a dead
    // server just burns the one reload the cooldown allows. Drop it; the
    // next confirmed recovery schedules a fresh one.
    if (this._reloadTimeout) {
      clearTimeout(this._reloadTimeout);
      this._reloadTimeout = null;
    }

    if (this.state.serverStatus !== 'DOWN') {
      this.setState({ serverStatus: 'DOWN' });
    }
    this.startHealthPolling();
  };

  // Everything on screen was fetched before the outage, and every request
  // made during it failed — tables sit empty, saves were rejected, the
  // sidebar counts are stale. Clearing the banner alone would leave a page
  // that looks healthy and isn't, so a confirmed recovery reloads.
  handleServerUpEvent = () => {
    this.stopHealthPolling();

    const recovering = this._sawServerDown;
    this._sawServerDown = false;

    if (!recovering || !this.canAutoReload()) {
      if (this.state.serverStatus !== 'UP') {
        this.setState({ serverStatus: 'UP' });
      }
      return;
    }

    this.setState({ serverStatus: 'RECOVERING' });
    this._reloadTimeout = setTimeout(() => {
      this._reloadTimeout = null;
      try {
        sessionStorage.setItem(RECOVERY_RELOAD_KEY, String(Date.now()));
      } catch (e) {
        // Storage disabled — worst case the cooldown stops working and a
        // flapping server reloads more than once. Still better than
        // skipping the reload entirely.
      }
      window.location.reload();
    }, RECOVERY_RELOAD_DELAY_MS);
  };

  canAutoReload = () => {
    try {
      const last = Number(sessionStorage.getItem(RECOVERY_RELOAD_KEY) || 0);
      return !last || Date.now() - last > RECOVERY_RELOAD_COOLDOWN_MS;
    } catch (e) {
      return true;
    }
  };

  // Recovery watch. A successful probe flips AuthUtil back to reachable,
  // which emits 'app:server-up' — so this loop tears itself down through
  // handleServerUpEvent rather than clearing the interval here.
  startHealthPolling = () => {
    if (this.healthPoll) return;
    this.healthPoll = setInterval(async () => {
      const alive = await AuthUtil.probeHealth();
      if (alive) AuthUtil.noteServerReachable();
    }, HEALTH_POLL_MS);
  };

  stopHealthPolling = () => {
    if (!this.healthPoll) return;
    clearInterval(this.healthPoll);
    this.healthPoll = null;
  };

  // Receives the lockState from AuthUtil's 423 handler. Same code path as
  // the WebSocket 'company-locked' branch in handleMessage, just sourced
  // from an HTTP response instead of a socket frame.
  //
  // Race: when a screen mounts with several parallel API calls in flight
  // (Dashboard fires alerts/points/etc on mount), each one returns 423
  // and dispatches this event. The prop check below catches duplicates
  // ONCE the redux update has been observed, but during the window
  // between dispatch and React commit, this.props.userInfo is still the
  // pre-lock value — so a prop-only guard misses concurrent dispatches.
  // The timestamp throttle (1s window) collapses any burst into a single
  // handler invocation regardless of when the props observe the change.
  handleAppLockedEvent = (event) => {
    const now = Date.now();
    if (this._lastLockEventAt && now - this._lastLockEventAt < 1000) return;
    this._lastLockEventAt = now;

    const lockState = event?.detail;
    if (!lockState) return;
    if (this.props.userInfo?.lockState?.locked) return; // already locked
    if (this.props.userInfo) {
      this.props.updateUserInfo({
        ...this.props.userInfo,
        lockState,
      });
    }
    this.props.refreshUserInfo();
  };

  /**
   * A guarded endpoint refused a write with NOT_CLOCKED_IN.
   *
   * The server is the authority on shift state and has already rejected the
   * entry; all that is left is to stop this page from looking usable. Two
   * steps, in order:
   *
   *   1. getUsers() — Header recomputes routes off the refreshed isClockedIn,
   *      which unmounts every shift-bound screen (see protectRoutes).
   *   2. Send them to /check-in-out so the next thing they see is the button
   *      that fixes it, rather than a screen that has just been pulled out
   *      from under them.
   *
   * Throttled: a page with several writes in flight (or an employee tapping
   * Save twice) produces a burst of identical refusals, and each one would
   * otherwise fire its own fetch and history push. Same 1s window and the
   * same reasoning as handleAppLockedEvent above.
   */
  handleShiftClosedEvent = () => {
    const now = Date.now();
    if (this._lastShiftClosedAt && now - this._lastShiftClosedAt < 1000) return;
    this._lastShiftClosedAt = now;

    // refreshUserInfo is what actually re-gates the app: it re-reads getUser,
    // which recomputes isClockedIn from ClockRecord, and allowedRoutes keys
    // off that. getUsers alongside it keeps Header's employee switcher in
    // step so the two views of "who is on shift" don't drift.
    this.props.refreshUserInfo();
    this.props.getUsers();

    // Only when the clock screen is genuinely available to them: not on
    // mobile, and not before the RFID chip has been tapped. Otherwise the
    // re-gating above has already unmounted the screen they were on and the
    // catch-all shows CheckIn404, which is where they should be.
    if (
      allowedRoutes(this.props.userInfo).includes('check-in-out') &&
      this.props.location.pathname !== '/check-in-out'
    ) {
      this.props.history.push('/check-in-out');
    }
  };

  initConnections = () => {
    const { isAuthenticated, userInfo, location } = this.props;
    const { isMobile } = this.state;

    const isCleanLayout =
      cleanLayoutPaths.includes(location.pathname) ||
      location.pathname.startsWith('/v/');

    if (!isAuthenticated) return;
    if (isCleanLayout) return;
    // Tech admins have ROLE_ADMIN for privilege reasons but still need
    // to receive Maintenance Permit broadcasts, so they bypass the
    // admin early-return and connect the shared WebSocket below.
    const isTechAdmin = this.userIsTechAdmin();

    // Roles that get none of the employee machinery below: no webcam, no
    // RFID keyboard capture, no employee list. They still get the header
    // banner feed — see the connectRFIDSocket call underneath.
    const bannerOnlyUser =
      (this.userIsAnAdmin() || this.userHasReadingPermission()) && !isTechAdmin;

    if (!userInfo?.selectedLocationId) return;

    // Both header banners ride the RFID socket, and nothing else does:
    // its ping/pong keep-alive is the earliest signal that the backend
    // went away, and MaintenanceWatcher broadcasts the scheduled-
    // maintenance announcement to every RFID session regardless of
    // location or role. The early-returns below exist to keep the
    // employee machinery off admin/reading sessions — but they also
    // silently withheld both banners from every role except a clocked-in
    // employee, so an owner, manager or reading user had no way to know
    // the server was restarting. Opening the socket here is listen-only:
    // connectRFIDSocket attaches no keydown listener and starts no
    // camera, and pong + the maintenance announcement are the only
    // messages the server ever sends on this channel.
    if (bannerOnlyUser || isTechAdmin) {
      this.connectRFIDSocket();
    }

    if (bannerOnlyUser) return;

    if (isTechAdmin) {
      if (!this.socketIsCurrent(this.socket)) {
        this.connectWebSocket();
      }
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      window.removeEventListener('keydown', this.handleKeyDown);
      this.stopCamera();
      return;
    }

    /* =====================
       📱 MOBILE (RFID ONLY), also connectWebSocket (alert)
       ===================== */
    if (isMobile) {
      if (!this.socketIsCurrent(this.socketRfid)) {
        this.connectRFIDSocket();
      }

      if (!this.socketIsCurrent(this.socket)) {
        this.connectWebSocket();
      }

      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );

      // Ensure desktop-only things are OFF. The general socket is NOT one
      // of them — mobile opens it above for the alert feed. Closing it
      // here was dead code (this.socket was permanently null) and would
      // now tear down the socket this branch had just opened.
      window.removeEventListener('keydown', this.handleKeyDown);
      this.stopCamera();

      return;
    }

    /* =====================
       🖥 DESKTOP (BOTH)
       ===================== */
    if (!this.socketIsCurrent(this.socket)) {
      this.connectWebSocket();
    }

    if (!this.socketIsCurrent(this.socketRfid)) {
      this.connectRFIDSocket();
    }

    this.props.getEmployees({
      locationId: userInfo.selectedLocationId,
    });

    window.removeEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keydown', this.handleKeyDown);

    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );

    this.startWebcam();
  };

  cleanupConnections = () => {
    // Cancel queued reconnects FIRST: closing a socket is what fires the
    // onclose that would otherwise schedule a fresh one on the way out.
    this.clearWsReconnect();
    this.clearRfidReconnect();

    this.closeWebSocket();
    this.closeRfidSocket();

    window.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );

    this.stopCamera();
  };

  openProfile = () => {
    this.setState({ showProfile: true }, () => {
      this.props.history.push('/profile');
    });
  };

  async requestWakeLock() {
    try {
      if ('wakeLock' in navigator && document.visibilityState === 'visible') {
        this.wakeLock = await navigator.wakeLock.request('screen');

        // Re-acquire when page becomes visible again
        document.addEventListener('visibilitychange', async () => {
          if (document.visibilityState === 'visible' && !this.wakeLock) {
            try {
              this.wakeLock = await navigator.wakeLock.request('screen');
            } catch (err) {
              console.error('Failed to re-request wake lock:', err.message);
            }
          } else if (document.visibilityState !== 'visible' && this.wakeLock) {
            await this.wakeLock.release();
            this.wakeLock = null;
          }
        });
      }
    } catch (err) {
      console.error('Wake Lock error:', err.name, err.message);
    }
  }

  async submitScan(rfid) {
    if (!rfid) return;

    try {
      const callback = (success, message) => {
        // Check if success is false AND the message matches your error string
        if (!success && message?.includes('RFID tag is not registered')) {
          this.setState({
            showSelfRegister: true,
            tempRfid: rfid,
            selectedEmployeeId: null,
          });
        }
        this.setState({ rfid: '' });
      };

      this.props.processRFID({ rfid: rfid }, callback);
    } catch (error) {
      console.error('Error submitting RFID scan:', error);
    }
  }

  // Returns whether the session was actually ended, so the hard-ceiling
  // caller can tell "logged them out" from "this role is exempt" — the
  // exempt case has to put the paused countdown back.
  handleOnIdle = () => {
    const { userInfo, isAuthenticated } = this.props;
    if (
      isAuthenticated &&
      (userInfo?.authority?.includes(ROLE_ADMIN) ||
        userInfo?.authority?.includes(ROLE_MASTER_ADMIN) ||
        userInfo?.authority?.includes('ROLE_READING'))
    ) {
      AuthUtil.handleLogout();
      return true;
    }
    return false;
  };

  // Stamped by real interaction only — never by pause/resume/reset — so it
  // stays the honest "last time anyone actually used the app" that the hard
  // ceiling is measured against.
  handleIdleAction = () => {
    this.lastActivityAt = Date.now();
  };

  // Freeze the inactivity countdown while the app is in the background, so
  // an employee who switches to another app (or another browser tab) does
  // not burn idle time against the work they were doing here. pause() banks
  // the time remaining; resume() restarts the countdown from that same
  // remaining time and stamps lastActive, so the hour only ever measures
  // inactivity while the app is actually in front of them — bounded by the
  // 8 hour ceiling.
  handleIdleVisibility = () => {
    if (!this.idleTimer) return;
    if (document.visibilityState === 'hidden') {
      this.idleTimer.pause();
      this.idlePaused = true;
    } else if (Date.now() - this.lastActivityAt >= IDLE_HARD_CEILING_MS) {
      // Gone past the ceiling. Pausing bought them the whole shift; this is
      // the app they left open overnight, so end it on the way back in.
      this.idlePaused = false;
      // Unless this role is one the ceiling doesn't end sessions for, in
      // which case they are simply back in the app: restart the hour rather
      // than leave the timer parked on the pause() from the hide event,
      // which would silently disable inactivity logout for the rest of the
      // session. lastActivityAt is deliberately NOT stamped here — only
      // real interaction moves it, so the next resume re-checks honestly.
      if (!this.handleOnIdle()) this.idleTimer.reset();
    } else if (this.idlePaused) {
      this.idlePaused = false;
      this.idleTimer.resume();
    } else {
      // Came back visible without ever having paused — the hide event never
      // reached us (mobile browsers can freeze a backgrounded page before it
      // fires). Reopening the app is activity, so restart the hour rather
      // than let a countdown that was still running expire on their face.
      this.idleTimer.reset();
    }
  };

  handleVisibilityChange = () => {
    if (this.userHasReadingPermission()) return;
    if (document.visibilityState === 'visible') {
      if (
        !this.socketIsCurrent(this.socket) ||
        this.socket.readyState !== WebSocket.OPEN
      ) {
        this.connectWebSocket();
        // if (!this.state.isMobile) {
        //   this.connectWebSocket();
        // }
      }

      if (
        !this.socketIsCurrent(this.socketRfid) ||
        this.socketRfid.readyState !== WebSocket.OPEN
      ) {
        this.connectRFIDSocket();
      }
    }
  };

  handleKeyDown = (event) => {
    if (!event?.key) return;
    if (this.timer) clearTimeout(this.timer);

    if (event.key === 'Enter') {
      const tag = this.buffer.trim();
      this.buffer = '';
      if (tag) {
        this.setState({ rfid: tag }, () => this.submitScan(tag));
      }
      return; // Stop execution here
    }

    if (event.key.length === 1) {
      this.buffer += event.key;
    }
    this.timer = setTimeout(() => {
      this.buffer = '';
    }, 500);
  };

  setRefresh = (bool) => {
    this.setState({ triggerUpdate: bool });
  };

  handleScreenChange = (event) => {
    // A phone rotated to landscape can exceed 800px — never let a real
    // mobile device flip back into desktop mode.
    this.setState({ isMobile: event.matches || Utils.isMobileDevice() });
  };

  // A socket counts as "the one we want" only if it is also bound to the
  // location the app is operating now. A switch normally arrives with a
  // full page reload, but updateSelectedCompany moves the location in
  // redux first — and any future in-place switch has to take the sockets
  // with it, or the app sits on the previous gameroom's channel.
  socketIsCurrent = (socket) =>
    !!socket && socket.locationId === this.props.userInfo?.selectedLocationId;

  connectRFIDSocket = () => {
    const { selectedLocationId } = this.props.userInfo;
    if (!selectedLocationId) {
      this.props.triggerRefresh(this.socketRfid);
      return;
    }

    // Prevent multiple simultaneous sockets
    if (
      this.socketIsCurrent(this.socketRfid) &&
      (this.socketRfid.readyState === WebSocket.OPEN ||
        this.socketRfid.readyState === WebSocket.CONNECTING)
    ) {
      console.log(
        'Socket already open or connecting. Skipping new connection.'
      );
      return;
    }

    // A reconnect already queued for this channel is now redundant — we
    // are connecting right here. Leaving it armed is how a navigation
    // during an outage ended up racing the timer and opening two.
    this.clearRfidReconnect();

    // Replace whatever is there: a CLOSING socket still holds a browser
    // connection slot and will fire its own onclose later, which the
    // supersede check in each handler now ignores.
    this.closeRfidSocket();

    const socket = new WebSocket(
      `${process.env.REACT_APP_RFID_WS_URL}?location=${selectedLocationId}`
    );
    // Which gameroom this socket is subscribed to. The server keys its
    // session map on it, so a socket opened for the previous location
    // keeps receiving that location's traffic — see socketIsCurrent.
    socket.locationId = selectedLocationId;
    // Claim the slot synchronously, BEFORE any handler can run.
    this.socketRfid = socket;

    // Every handler below belongs to THIS socket. Once it has been
    // superseded its events say nothing about the connection we are
    // actually using, and acting on them is what produced phantom
    // "server down" probes and duplicate reconnects.
    const isCurrent = () => this.socketRfid === socket;

    let pingTimeout;

    socket.onopen = () => {
      if (!isCurrent()) {
        socket.close();
        return;
      }
      console.log('RFID socket connected.');
      this.setState({ serverStatus: 'UP' });
      // Keep AuthUtil's module-level reachability flag in step with the
      // banner. Without this the socket could clear the banner while
      // AuthUtil still believed the backend was gone — and it suppresses
      // its own 'app:server-down' while it thinks so, which would swallow
      // the next real outage.
      AuthUtil.noteServerReachable();

      // Keep-alive handle lives ON the socket, not on the component: a
      // single shared field meant a second socket's interval overwrote
      // the first one's handle, and the first interval then ran forever
      // because onclose could only ever clear the current one.
      socket.keepAlive = setInterval(() => {
        // Off screen the OS freezes this timer and usually kills the
        // socket underneath it, so the tick that lands the moment the
        // employee switches back is measuring the app waking up, not the
        // backend. Skip it — the reconnect below re-establishes the
        // socket, and the next tick pings a connection that is really up.
        if (document.visibilityState !== 'visible') {
          clearTimeout(pingTimeout);
          return;
        }

        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ type: 'ping' }));

          // Wait for pong
          pingTimeout = setTimeout(() => {
            console.warn('No pong received, probing health.');
            AuthUtil.noteServerUnreachable('rfid-no-pong');
          }, 5000); // 5 sec to wait for pong
        }
      }, 30000); // every 30 sec
    };

    socket.onmessage = (event) => {
      if (!isCurrent()) return;
      try {
        const message = JSON.parse(event.data);
        if (message.type === 'pong') {
          clearTimeout(pingTimeout);
          AuthUtil.noteServerReachable();
          if (this.state.serverStatus !== 'UP') {
            this.setState({ serverStatus: 'UP' });
          }
        } else {
          this.handleMessage(message);
        }
      } catch (error) {
        console.error(
          'Error parsing WebSocket message:',
          error,
          'Received:',
          event.data
        );
      }
    };

    socket.onerror = (error) => {
      if (!isCurrent()) return;
      console.error('RFID WebSocket error:', error);
      // A dead socket is a hint, not a verdict. Corporate proxies, captive
      // portals and phone carriers kill WebSockets while plain HTTP keeps
      // working, so let AuthUtil confirm against /health/ping first — it
      // emits 'app:server-down' (and starts the recovery poll) only if the
      // backend really is unreachable. That check matters more now that
      // every role holds this socket, not just in-store employees.
      AuthUtil.noteServerUnreachable('rfid-socket-error');

      // Only attempt reconnect if socket is not open
      this.scheduleRfidReconnect();
    };

    socket.onclose = (event) => {
      clearInterval(socket.keepAlive);
      clearTimeout(pingTimeout);
      if (!isCurrent()) return;
      console.log('RFID socket closed.', event.reason);
      this.socketRfid = null;
      AuthUtil.noteServerUnreachable('rfid-socket-closed');

      this.scheduleRfidReconnect();
    };
  };

  scheduleRfidReconnect = () => {
    if (this._isUnmounting || this._reconnectTimeout) return;
    this._reconnectTimeout = setTimeout(() => {
      this._reconnectTimeout = null;
      this.connectRFIDSocket();
    }, 2000);
  };

  clearRfidReconnect = () => {
    if (!this._reconnectTimeout) return;
    clearTimeout(this._reconnectTimeout);
    this._reconnectTimeout = null;
  };

  // Drop the current RFID socket and its timer. Clearing the field first
  // makes every handler this close is about to fire read as superseded.
  closeRfidSocket = () => {
    const socket = this.socketRfid;
    if (!socket) return;
    this.socketRfid = null;
    clearInterval(socket.keepAlive);
    try {
      socket.close();
    } catch (e) {
      // Already closing/closed — nothing to do.
    }
  };

  connectWebSocket = () => {
    const { selectedLocationId } = this.props.userInfo;
    if (!selectedLocationId) {
      if (this.socket) this.props.triggerRefresh(this.socket);
      return;
    }

    // Prevent multiple simultaneous sockets
    if (
      this.socketIsCurrent(this.socket) &&
      (this.socket.readyState === WebSocket.OPEN ||
        this.socket.readyState === WebSocket.CONNECTING)
    ) {
      console.log(
        'WebSocket already open or connecting. Skipping new connection.'
      );
      return;
    }

    // See connectRFIDSocket: a queued reconnect is redundant once we are
    // connecting by hand, and leaving it armed races this call.
    this.clearWsReconnect();

    // Clean up previous socket
    this.closeWebSocket();

    const clientType = this.userIsTechAdmin()
      ? 'tech-admin'
      : this.state.isMobile
      ? 'alert'
      : 'camera';
    const socket = new WebSocket(
      `${process.env.REACT_APP_WS_URL}?location=${selectedLocationId}&type=${clientType}`
    );
    socket.locationId = selectedLocationId;
    // Claim the slot synchronously, before any handler can run.
    this.socket = socket;
    const isCurrent = () => this.socket === socket;

    socket.onopen = () => {
      if (!isCurrent()) {
        socket.close();
        return;
      }
      console.log('WebSocket connected.');

      // Trigger refresh only after connection
      this.props.triggerRefresh(socket);

      // Keep-alive handle on the socket — see connectRFIDSocket.
      socket.keepAlive = setInterval(() => {
        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ type: 'ping' }));
        }
      }, 30000); // every 30 sec
    };

    socket.onmessage = (event) => {
      if (!isCurrent()) return;
      try {
        const message = JSON.parse(event.data);
        this.handleMessage(message);
      } catch (error) {
        console.error(
          'Error parsing WebSocket message:',
          error,
          'Received:',
          event.data
        );
      }
    };

    socket.onclose = () => {
      clearInterval(socket.keepAlive);
      if (!isCurrent()) return;
      console.log('WebSocket closed.');
      this.socket = null;

      this.scheduleWsReconnect();
    };

    socket.onerror = (error) => {
      if (!isCurrent()) return;
      console.error('WebSocket error:', error);
      this.scheduleWsReconnect();
    };
  };

  scheduleWsReconnect = () => {
    if (this._isUnmounting || this._wsReconnectTimeout) return;
    this._wsReconnectTimeout = setTimeout(() => {
      this._wsReconnectTimeout = null;
      this.connectWebSocket();
    }, 2000);
  };

  clearWsReconnect = () => {
    if (!this._wsReconnectTimeout) return;
    clearTimeout(this._wsReconnectTimeout);
    this._wsReconnectTimeout = null;
  };

  closeWebSocket = () => {
    const socket = this.socket;
    if (!socket) return;
    this.socket = null;
    clearInterval(socket.keepAlive);
    try {
      socket.close();
    } catch (e) {
      // Already closing/closed — nothing to do.
    }
  };

  handleMessage = (message) => {
    const hasCompanyIds =
      this.props.userInfo.companyIds &&
      this.props.userInfo.companyIds.length > 0;

    if (message.action === 'captureImage') {
      if (!hasCompanyIds && !this.state.isMobile) {
        this.captureImage(message.pendingId);
        this.props.triggerRefresh(this.socket);
      }
    } else if (message.action === 'black-list-alert') {
      // 1. Set the alert data into state to be passed to children
      this.props.setBlacklistAlert({
        show: true,
        customer: message.customer,
      });
    } else if (message.action === 'refreshData') {
      this.props.triggerRefresh(true);
      this.setRefresh(true);
      setTimeout(() => {
        this.setRefresh(false);
      }, 1000);
    } else if (message.action === 'access-changed') {
      // A cross-company grant was just approved or revoked. Same shape as
      // 'company-locked' below: re-read getUser, which brings back the
      // updated location lists (so a new location appears in the picker)
      // and, if the location being viewed was the one revoked, drops this
      // session back to its own company. Reaches every browser at both
      // companies; for anyone unaffected it is one cheap no-op fetch.
      this.props.refreshUserInfo();
    } else if (message.action === 'refreshAlerts') {
      // A points photo at this location was flagged (no clear face) or cleared
      // — re-pull the navbar alerts so the bell updates without a reload.
      const locationId = this.props.userInfo?.selectedLocationId;
      if (locationId) this.props.fetchAlerts({ locationId });
    } else if (message.action === 'announcement') {
      this.setState({
        announcementMessage: message.msg,
        announcementEnd: message.datetime,
      });
    } else if (message.action === 'removeAnnouncement') {
      this.setState({ announcementMessage: null, announcementEnd: null });
    } else if (message.action === 'company-locked') {
      // Server flipped this company into a locked state (license expired,
      // trial-grace expired, admin-suspended). Bearer tokens are kept
      // alive for billing-related lock reasons so the browser can stay
      // authenticated — we just need fresh userInfo with lockState, then
      // Base.jsx re-renders into LockedShell in-place.
      //
      // Guard: the broadcast reaches every WS subscriber for the company
      // — including multi-company NDS staff who are temporarily viewing
      // this client. Those users' OWN home company isn't locked, so
      // their canonical lockState is null. Without this guard they'd
      // briefly transition into LockedShell then flicker back when
      // refreshUserInfo returns the correct null. Compare against
      // userInfo.company (the home company), not selectedLocationId.
      const incomingLockState = message.lockState;
      const myHomeCompany = this.props.userInfo?.company;
      const broadcastCompany = incomingLockState?.companyId;
      const affectsMe =
        !broadcastCompany ||
        !myHomeCompany ||
        broadcastCompany === myHomeCompany;
      // Idempotency: share the same timestamp throttle handleAppLockedEvent
      // uses, so WS and HTTP-event paths don't race. Without this, a WS
      // broadcast arriving simultaneously with several in-flight 423s
      // would all dispatch updateUserInfo + refreshUserInfo, producing a
      // re-render storm.
      const alreadyLocked = this.props.userInfo?.lockState?.locked === true;
      const now = Date.now();
      const throttled =
        this._lastLockEventAt && now - this._lastLockEventAt < 1000;
      if (affectsMe && incomingLockState && !alreadyLocked && !throttled) {
        this._lastLockEventAt = now;
        // OPTIMISTIC local update so the transition is instant even if
        // the network refresh lags. The broadcast payload is built
        // server-side with a null user (role-agnostic), so we re-compute
        // canActivate / canPay locally from the user's own authority
        // array — avoids briefly showing the "contact your manager"
        // employee card to an owner. refreshUserInfo then overwrites
        // with the authoritative payload from getUserInfo.
        const roles = this.props.userInfo?.authority || [];
        const ACTIVATE_ROLES = [
          'ROLE_TECH_ADMIN',
          'ROLE_MASTER_ADMIN',
          'ROLE_OWNER',
          'ROLE_ADMIN',
          'ROLE_COMPANY',
        ];
        // Must stay in sync with CompanyService.PAY_ROLES — Manager
        // (ROLE_ADMIN) is included so a manager-level user can self-pay
        // from the LockedShell when the owner is unreachable.
        const PAY_ROLES = [
          'ROLE_TECH_ADMIN',
          'ROLE_MASTER_ADMIN',
          'ROLE_OWNER',
          'ROLE_ADMIN',
        ];
        const terminal = incomingLockState.terminal === true;
        const localLockState = {
          ...incomingLockState,
          canActivate:
            !terminal && roles.some((r) => ACTIVATE_ROLES.includes(r)),
          canPay: !terminal && roles.some((r) => PAY_ROLES.includes(r)),
        };
        this.props.updateUserInfo({
          ...this.props.userInfo,
          lockState: localLockState,
        });
        this.props.refreshUserInfo();
      }
      // For NDS staff who don't match, no-op. They keep their unlocked
      // session and can continue to manage / view the locked company
      // (the LockGateInterceptor lets their requests through because
      // their own company is active).
    } else if (message.action === 'company-unlocked') {
      // Inverse of the above — an owner pay or admin re-activation cleared
      // the lock. Re-fetch userInfo so lockState becomes null and the full
      // app shell remounts. Only refresh if we're currently locked —
      // otherwise the unlock broadcast triggers needless re-renders for
      // users who weren't in the locked shell to begin with (multi-company
      // NDS staff, users who just logged in to an already-active company).
      if (this.props.userInfo?.lockState?.locked) {
        this.props.refreshUserInfo();
      }
    } else if (
      message.action === 'permit-granted' ||
      message.action === 'permit-revoked' ||
      message.action === 'permit-expired'
    ) {
      // Maintenance Permit changed at some location. Refresh the
      // company picker so the tech admin (or any NDS staff) sees the
      // location appear/disappear without having to reload. If the
      // location they're currently viewing just lost its permit,
      // kick them back to NDS so they can't keep operating in a site
      // they no longer have access to — clear the selected location
      // in Redux *before* the reload so the company picker doesn't
      // still point at the revoked site after re-hydration.
      if (this.userIsTechAdmin()) {
        this.props.listAvailableCompanies();
        const { userInfo } = this.props;
        const revoked =
          message.action !== 'permit-granted' &&
          message.locationId &&
          userInfo?.selectedLocationId === message.locationId;
        if (revoked) {
          const homeLocationId = userInfo?.company || null;
          this.props.updateUserInfo({
            ...userInfo,
            selectedLocationId: homeLocationId,
            selectedLocationName: homeLocationId ? 'NuVe System' : '',
          });
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }
    }
  };

  startWebcam = async () => {
    if (this.state.isMobile) {
      return;
    }

    // Warm up the face-detection models so the first capture isn't delayed.
    // No-ops gracefully if the model files aren't deployed yet.
    loadFaceModels();

    // Idempotent. initConnections runs on every navigation, and each pass
    // used to mint a fresh MediaStream: assigning srcObject only drops the
    // reference to the previous stream, it never stops its tracks, so the
    // old camera capture kept running. One live stream per session.
    const live = this.videoRef.current?.srcObject;
    if (live && live.getTracks().some((t) => t.readyState === 'live')) {
      return;
    }

    // Check if the ref is available
    if (this.videoRef.current) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        // Ensure the videoRef.current is not null before setting srcObject
        if (this.videoRef.current) {
          this.videoRef.current.srcObject = stream;
          this.videoRef.current.play();
        }
      } catch (err) {
        console.error('Error accessing webcam: ', err);
      }
    } else {
      console.error('Video ref is not available');
    }
  };

  sendFileToServer = (pendingId, file, faceAssessment) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('pendingId', pendingId);
    // Only forward a verdict we actually computed — when detection couldn't
    // run (models missing) the assessment is null and we omit it so the server
    // keeps its "photo present = OK" fallback instead of false-flagging.
    if (faceAssessment) {
      formData.append('faceDetected', String(faceAssessment.faceDetected));
      formData.append('faceVerdict', faceAssessment.verdict);
    }

    fetch(`${BASE_URL}/customer/saveCustomerPointWatching`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: formData,
    }).catch((err) => console.error('Upload error:', err));
  };

  // Kiosk enrollments arrive back-to-back (2-3 customers in a row), each one
  // a WebSocket 'captureImage' message. The frame must be frozen the moment
  // the message lands — into a PRIVATE canvas, never a shared one — because
  // face detection can take seconds (SSD fallback + one-time model download)
  // and a shared canvas would get redrawn by the next customer mid-detection,
  // uploading customer B's photo under customer A's pendingId.
  captureImage = (pendingId) => {
    const video = this.videoRef.current;
    if (!video) return;

    const snapshot = document.createElement('canvas');
    snapshot.width = 640;
    snapshot.height = 480;
    snapshot.getContext('2d').drawImage(video, 0, 0, 640, 480);

    // Detection + upload run one at a time, in enrollment order.
    this.enqueueCapture({ canvas: snapshot, pendingId });
  };

  processCapture = async ({ canvas, pendingId }) => {
    // Run face detection on the captured frame ({faceDetected, verdict} or
    // null=unknown). Failures never block the upload — the photo is still
    // recorded.
    let faceAssessment = null;
    try {
      faceAssessment = await detectFace(canvas);
    } catch (err) {
      faceAssessment = null;
    }

    // 0.25 quality — still clear face, ~30-60KB per image
    const compressedImageURL = canvas.toDataURL('image/jpeg', 0.5);
    const uniqueFileName = `${Date.now()}_${Math.floor(
      Math.random() * 10000
    )}.jpg`;
    this.handleFileAdd(
      compressedImageURL,
      pendingId,
      uniqueFileName,
      faceAssessment
    );
  };

  handleFileAdd = (fileDataURL, pendingId, fileName, faceAssessment) => {
    fetch(fileDataURL)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], fileName, { type: 'image/jpeg' });
        this.sendFileToServer(pendingId, file, faceAssessment);
      });
  };

  // True when the path corresponds to a REAL route (public or protected),
  // regardless of whether the current user may access it. Used by the
  // catch-all so a logged-out hit on a real-but-gated route (e.g. /dashboard)
  // still falls back to Login, while a genuinely unknown URL (/asdsa) shows
  // the 404 page instead of the login screen.
  isKnownPath = (pathname) => {
    if (!pathname) return false;
    const all = [...getRoutes(), ...routes];
    return all.some(
      (r) => r.path && matchPath(pathname, { path: r.path, exact: false })
    );
  };

  // Human-readable name for the current route, taken from the route table's
  // `label`. Drives a central per-route document.title for the authenticated
  // app pages (Dashboard, Customer, …) that don't render their own <Seo>.
  // Returns null for "/" and any unmatched path so the page's own <Seo>
  // (landing, login, legal pages) stays in control.
  currentRouteLabel = () => {
    const pathname = this.props.location && this.props.location.pathname;
    if (!pathname) return null;
    const all = [...getRoutes(), ...routes];
    const match = all.find(
      (r) =>
        r.path && r.label && matchPath(pathname, { path: r.path, exact: true })
    );
    return match ? match.label : null;
  };

  protectRoutes = () => {
    // allowedRoutes, not userInfo.routes: a clocked-out employee is cut down
    // to Check In / Out here, synchronously, on the very first render. Reading
    // userInfo.routes directly meant a typed URL like /ticket-out mounted the
    // screen from the rehydrated (granted) route list and only collapsed once
    // Header's getUsers round-trip landed — and refreshUserInfo would often
    // overwrite it back. See constants/clockInAccess.js.
    const userRoutes = allowedRoutes(this.props.userInfo);
    const hasAccess = (route) => {
      if (userRoutes.includes(route.id)) return true;
      if (
        route.requiresAnyOf &&
        route.requiresAnyOf.some((id) => userRoutes.includes(id))
      ) {
        return true;
      }
      return false;
    };
    // NOTE: deliberately NOT filtered by roleMenuVisibility. That map hides
    // menu ENTRIES; the routes themselves must still mount so a bookmarked
    // URL keeps working and nobody is hard-locked out of a screen.
    return getRoutes().filter(hasAccess).concat(routes);
  };

  stopCamera = () => {
    if (this.videoRef.current && this.videoRef.current.srcObject) {
      const stream = this.videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      this.videoRef.current.srcObject = null;
    }
  };

  leftMenuRoutes = () => {
    let displayedRoutes = [];
    // Same source as protectRoutes, so the sidebar and the router can never
    // disagree about where this user is allowed to be.
    const userRoutes = allowedRoutes(this.props.userInfo);
    const authorities = this.props.userInfo?.authority || [];
    const viewOnly = this.props.userInfo?.accessMode === 'VIEW';
    let dividerCount = 0;
    const hasAccess = (route) => {
      // Screens that are structurally empty for this user's role never
      // reach the sidebar. Dropped here — the single source for both the
      // desktop menu and the validPaths list derived from it — so the two
      // can't drift. See constants/roleMenuVisibility.js.
      if (isRouteHiddenForUser(route.id, authorities, viewOnly)) return false;
      if (userRoutes.includes(route.id)) return true;
      if (
        route.requiresAnyOf &&
        route.requiresAnyOf.some((id) => userRoutes.includes(id))
      ) {
        return true;
      }
      return false;
    };
    protectedRoutes.map((route) => {
      if (route.type === ROUTE_TYPE.DIVIDER) {
        if (dividerCount === 0) {
          displayedRoutes = [...displayedRoutes, route];
          dividerCount++;
        }
      } else if (hasAccess(route)) {
        displayedRoutes = [...displayedRoutes, route];
        dividerCount = 0;
      }
      return null;
    });
    return displayedRoutes;
  };

  userIsAnAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MASTER_ADMIN');
  };

  userIsTechAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    // Owners have every role baked in, so a raw ROLE_TECH_ADMIN check
    // would treat them as tech admins too. Only treat someone as a
    // real tech admin when they have the role *without* being an owner.
    return roles.includes(ROLE_TECH_ADMIN) && !roles.includes('ROLE_OWNER');
  };

  userHasReadingPermission = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_READING');
  };

  handleEmployeeChange = (event, newValue) => {
    this.setState({
      selectedEmployeeId: newValue ? newValue.userId : null,
    });
  };

  registerTag = () => {
    const { tempRfid, selectedEmployeeId } = this.state;

    if (!selectedEmployeeId) return;

    this.setState({ isSubmitting: true });

    const data = {
      userId: selectedEmployeeId,
      rfid: tempRfid.trim(),
    };

    const callback = (success, response) => {
      if (success) {
        this.setState({
          showSelfRegister: false,
          tempRfid: '',
          selectedEmployeeId: null,
          isSubmitting: false,
          feedbackOpen: true,
          feedbackMessage: 'RFID Tag successfully linked to employee!',
          feedbackSeverity: 'success',
        });
        this.setRefresh(true);
      } else {
        this.setState({
          isSubmitting: false,
          feedbackOpen: true,
          feedbackMessage:
            response || 'Failed to register tag. Please try again.',
          feedbackSeverity: 'error',
        });
      }
    };

    this.props.registerRFID(data, callback);
  };

  render() {
    const { isMobile } = this.state;
    const { showingMenuItems, isAuthenticated, location } = this.props;

    const isCleanLayout =
      cleanLayoutPaths.includes(location.pathname) ||
      location.pathname.startsWith('/v/');

    const routes = this.leftMenuRoutes().filter((route) => route.id);
    let validPaths = routes.map((route) => route.id);
    if (isMobile) {
      if (validPaths.length !== 1) {
        validPaths = validPaths.filter((id) => id !== 'check-in-out');
      }
    }
    const isValid = validPaths.includes('check-in-out');

    const filteredEmployees = (
      Array.isArray(this.props.employees)
        ? this.props.employees
        : [this.props.employees]
    ).filter((emp) => {
      // 0. Remove disabled employees
      if (emp.isEnabled === false) return false;

      // 1. Exclude ROLE_ADMIN, ROLE_MASTER_ADMIN, ROLE_MANAGER
      const hasAdminRole =
        Array.isArray(emp.authorities) &&
        emp.authorities.some(
          (a) =>
            a.authority === 'ROLE_ADMIN' ||
            a.authority === 'ROLE_MASTER_ADMIN' ||
            a.authority === 'ROLE_MANAGER'
        );

      if (hasAdminRole) return false;

      // 2. Exclude the non-RFID kiosk/security roles. Tablet (NuVePad)
      //     accounts and dedicated Security guards never tap an RFID gate,
      //     so they should not appear in the "assign unregistered tag"
      //     picker. "Dedicated Security" = ROLE_SECURITY without customer
      //     access (mirrors the login redirect's isDedicatedSecurity); a
      //     Supervisor/Manager who merely has the Security section enabled
      //     also carries ROLE_CUSTOMER and is therefore NOT excluded here.
      const empRoles = Array.isArray(emp.authorities)
        ? emp.authorities.map((a) => a.authority)
        : [];
      const isTablet = empRoles.includes('ROLE_TABLET');
      const isDedicatedSecurity =
        empRoles.includes('ROLE_SECURITY') &&
        !empRoles.includes('ROLE_CUSTOMER');

      if (isTablet || isDedicatedSecurity) return false;

      // 3. Show only employees WITHOUT RFID
      const hasRfid = emp.rfid != null && String(emp.rfid).trim() !== '';

      return !hasRfid;
    });

    // Trial companies used to get a persistent "pay within N days" bar
    // pinned above the whole shell. They're now nudged the same way every
    // other company is — LICENSE_EXPIRY alerts in the notification bell,
    // raised by LicenseExpiryJob at 15/7/3/1 days before the free month
    // ends — so there's no banner here any more.

    // Unified lock check. lockState.locked covers every disabled-company
    // scenario (license expired, trial-grace expired, admin-suspended).
    // When present we short-circuit the entire app shell into LockedShell
    // — no header, no sidebar, no feature routes are mounted. Server-side
    // the 423 gate already blocks feature endpoints, but this is the
    // first line of defense and the user-facing UX.
    const lockState = this.props.userInfo?.lockState;
    if (isAuthenticated && lockState && lockState.locked) {
      return <LockedShell />;
    }

    // Central per-route title for authenticated app pages. Pages that render
    // their own deeper <Seo> (landing, login, legal) override this — react-
    // helmet-async lets the last-rendered title win, with no duplicate tags.
    // noindex: these are internal app screens that shouldn't be in search.
    const routeLabel = this.currentRouteLabel();

    return (
      <>
        {routeLabel && (
          <Seo title={routeLabel} path={this.props.location.pathname} noindex />
        )}
        <div className="main-layout-wrapper">
          <div className="custom-container-fluid content-grow">
            <div style={{ width: '100%' }} ref={this.shellRef}>
              {isAuthenticated && !isCleanLayout && (
                <>
                  {/* Backstop for writes that slip past the greyed-out
                      controls (timers, retries, unswept surfaces). */}
                  <ReadOnlyToast />
                  <Header
                    logout={this.props.authLogout}
                    firstname={this.props.userInfo.firstname}
                    userRoutes={[...this.props.userInfo.routes]}
                    routes={this.leftMenuRoutes()}
                    refresh={this.state.triggerUpdate}
                    setRefresh={this.setRefresh}
                    isAuthenticated={this.props.isAuthenticated}
                    announcementMessage={this.state.announcementMessage}
                    announcementEnd={this.state.announcementEnd}
                    serverStatus={this.state.serverStatus}
                    openProfile={this.openProfile}
                  />
                  <IdleTimer
                    ref={(ref) => (this.idleTimer = ref)}
                    timeout={IDLE_TIMEOUT_MS}
                    events={IDLE_ACTIVITY_EVENTS}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleIdleAction}
                    debounce={500}
                  />
                </>
              )}
              {this.props.isAuthenticated && (
                <input
                  type="text"
                  ref={this.inputRef}
                  onKeyDown={this.handleKeyDown}
                  onBlur={() => this.inputRef.current?.focus()}
                  style={{ opacity: 0, position: 'absolute' }}
                />
              )}

              <div className="custom-container-fluid">
                {!isCleanLayout && (
                  <div
                    className="leftContainer"
                    style={{ backgroundColor: '#000c36', color: 'white' }}
                  >
                    {this.props.isAuthenticated &&
                      window.screen.width > 800 && (
                        <Slide
                          direction="right"
                          in={this.props.showingMenuItems}
                          mountOnEnter
                          unmountOnExit
                        >
                          <LeftMenu
                            logout={this.props.authLogout}
                            routes={this.leftMenuRoutes()}
                            userRoutes={[...this.props.userInfo.routes]}
                            // The mobile drawer in Header.jsx already passes
                            // this; the desktop sidebar never did, so every
                            // role check inside MenuItems (hidden routes,
                            // isMasterAdmin) silently no-opped here.
                            user={this.props.userInfo}
                            isDrawer={false}
                          />
                        </Slide>
                      )}
                  </div>
                )}

                <div
                  className={
                    showingMenuItems &&
                    !isMobile &&
                    isAuthenticated &&
                    !isCleanLayout
                      ? 'rightContainer'
                      : 'fullWidthContainer'
                  }
                >
                  <Switch>
                    {this.protectRoutes().map((route) => (
                      <Route
                        key={route.id}
                        component={route.component}
                        path={route.path}
                      />
                    ))}

                    <Route exact path="/">
                      {isAuthenticated ? (
                        <Redirect to="/dashboard" />
                      ) : (
                        // Render the landing page in place so the URL stays at
                        // "/" (no redirect to /landing). history is passed
                        // through for in-app nav to /login.
                        <LandingPage history={this.props.history} />
                      )}
                    </Route>

                    {/* Catch-all for any other unmatched routes */}
                    <Route path="*">
                      {isAuthenticated ? (
                        // CLOCKED OUT, on a real screen they can no longer
                        // reach — /ticket-out typed into the address bar, or a
                        // bookmark. protectRoutes has already unmounted it, so
                        // without this they land on the catch-all and get a 404
                        // (or ClockInOut rendered under the wrong URL, which
                        // then breaks on refresh).
                        //
                        // Redirect when the clock screen is actually one of
                        // their routes — desktop AND the chip has been tapped.
                        // Otherwise CheckIn404 ("you're not clocked in, scan
                        // your Chip"), which covers desktop-before-the-chip and
                        // every mobile case, since mobile is never offered the
                        // clock at all.
                        //
                        // CheckIn404 is stated explicitly here rather than left
                        // to the branches below: those decide via `isValid`,
                        // which is derived from the sidebar routes, so a
                        // clocked-out mobile user (no routes at all) fell
                        // through to the sessionId test and got PageNotFound —
                        // a bare 404 where the "not clocked in" screen belongs.
                        //
                        // Unknown junk still 404s below.
                        isClockedOut(this.props.userInfo) &&
                        this.isKnownPath(location.pathname) ? (
                          allowedRoutes(this.props.userInfo).includes(
                            'check-in-out'
                          ) ? (
                            <Redirect to="/check-in-out" />
                          ) : (
                            <CheckIn404 />
                          )
                        ) : // A genuinely unknown URL (typo/garbage like /asdsa)
                        // is a 404 — never the clock-in / default screen. The
                        // clock-in fallback below is only for KNOWN routes the
                        // user can't access (e.g. a clock-only employee whose
                        // "/" redirect to /dashboard lands here).
                        !this.isKnownPath(location.pathname) ? (
                          <PageNotFound />
                        ) : isMobile ? (
                          isValid ? (
                            <CheckIn404 />
                          ) : this.props.userInfo.sessionId ? (
                            <PageNotFound />
                          ) : (
                            <CheckIn404 />
                          )
                        ) : isValid ? (
                          <ClockInOut />
                        ) : this.props.userInfo.sessionId ? (
                          <PageNotFound />
                        ) : (
                          <CheckIn404 />
                        )
                      ) : this.isKnownPath(location.pathname) ? (
                        // A real route the visitor must sign in to reach.
                        <Login />
                      ) : (
                        // Genuinely unknown URL → 404, not the login screen.
                        <PageNotFound />
                      )}
                    </Route>
                  </Switch>
                </div>
              </div>
            </div>
          </div>

          {/* Landing page ships its own footer; suppress the thin app
              footer on the landing routes ("/", "/landing") and the full-page
              Get Started wizard to avoid a duplicate / stray footer. */}
          {location.pathname !== '/landing' &&
            location.pathname !== '/' &&
            location.pathname !== '/get-started' && <Footer />}
          <video ref={this.videoRef} style={{ display: 'none' }} />
        </div>

        <Snackbar
          open={this.state.feedbackOpen}
          autoHideDuration={5000}
          onClose={() => this.setState({ feedbackOpen: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => this.setState({ feedbackOpen: false })}
            severity={this.state.feedbackSeverity}
            variant="filled"
            elevation={6}
          >
            {this.state.feedbackMessage}
          </Alert>
        </Snackbar>

        {this.props.blacklistAlert?.show && (
          <>
            <Dialog
              fullScreen={this.state.isMobile}
              open={true}
              maxWidth="md"
              fullWidth
              PaperProps={{
                style: {
                  borderRadius: this.state.isMobile ? 0 : 12,
                  overflow: 'hidden',
                },
              }}
            >
              {/* --- SHARED HEADER --- */}
              <div
                style={{
                  backgroundColor: '#b71c1c',
                  color: 'white',
                  padding: this.state.isMobile ? '16px' : '24px',
                  textAlign: 'center',
                  borderBottom: '6px solid #801313',
                  textTransform: 'uppercase',
                }}
              >
                <h1
                  style={{
                    margin: 0,
                    fontSize: this.state.isMobile ? '1.5rem' : '2.2rem',
                    fontWeight: 900,
                  }}
                >
                  <span
                    role="img"
                    aria-label="siren"
                    style={{ marginRight: '10px' }}
                  >
                    🚨
                  </span>
                  Blacklist Alert
                </h1>
                <p
                  style={{
                    margin: '4px 0 0',
                    fontSize: this.state.isMobile ? '0.9rem' : '1.2rem',
                    fontWeight: 500,
                    opacity: 0.9,
                  }}
                >
                  Access Denied - Do Not Allow Entry
                </p>
              </div>

              <DialogContent
                style={{ padding: this.state.isMobile ? 0 : '32px' }}
              >
                {this.state.isMobile ? (
                  /* --- MOBILE LAYOUT (Stacked) --- */
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div onClick={() => this.setState({ isImageZoomed: true })}>
                      <img
                        src={this.props.blacklistAlert.customer.files?.[0]?.localURL?.replace(
                          /\\/g,
                          '/'
                        )}
                        style={{
                          width: '100%',
                          height: '45vh',
                          objectFit: 'cover',
                        }}
                        alt="Customer"
                      />
                    </div>
                    <div
                      style={{
                        marginLeft: '16px',
                        marginRight: '16px',
                        marginTop: '16px',
                        textAlign: 'left',
                      }}
                    >
                      <Typography
                        variant="overline"
                        style={{ color: '#d32f2f', fontWeight: 'bold' }}
                      >
                        CUSTOMER IDENTITY
                      </Typography>
                      <Typography
                        variant="h4"
                        style={{
                          fontWeight: 900,
                          color: '#222',
                          textTransform: 'uppercase',
                        }}
                      >
                        {this.props.blacklistAlert.customer.firstName}{' '}
                        {this.props.blacklistAlert.customer.lastName}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ color: '#666', marginBottom: '20px' }}
                      >
                        {this.props.blacklistAlert.customer.phone}
                      </Typography>
                    </div>
                    <div
                      style={{
                        marginLeft: '16px',
                        marginRight: '16px',
                        textAlign: 'center',
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: '#fff5f5',
                          border: '2px dashed #d32f2f',
                          padding: '16px',
                          borderRadius: '8px',
                          marginBottom: '24px',
                        }}
                      >
                        <Typography
                          variant="caption"
                          style={{
                            color: '#d32f2f',
                            fontWeight: 'bold',
                            display: 'block',
                          }}
                        >
                          REASON
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{ fontWeight: 'bold' }}
                        >
                          "{this.props.blacklistAlert.customer.blockReason}"
                        </Typography>
                      </div>

                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: '#000',
                          color: '#fff',
                          padding: '16px',
                          fontWeight: 'bold',
                          borderRadius: '8px',
                          marginBottom: '24px',
                        }}
                        onClick={() =>
                          this.props.setBlacklistAlert({
                            show: false,
                            customer: null,
                          })
                        }
                      >
                        ACKNOWLEDGE & DISMISS ALERT
                      </Button>
                    </div>
                  </div>
                ) : (
                  /* --- DESKTOP LAYOUT (Side-by-Side) --- */
                  <Grid container spacing={4} alignItems="center">
                    <Grid item xs={6}>
                      <div
                        style={{ cursor: 'zoom-in', position: 'relative' }}
                        onClick={() => this.setState({ isImageZoomed: true })}
                      >
                        <img
                          src={this.props.blacklistAlert.customer.files?.[0]?.localURL?.replace(
                            /\\/g,
                            '/'
                          )}
                          style={{
                            width: '100%',
                            height: '420px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                          }}
                          alt="Customer"
                        />
                        <div
                          style={{
                            position: 'absolute',
                            bottom: 12,
                            right: 12,
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            fontSize: '0.8rem',
                          }}
                        >
                          CLICK TO ENLARGE
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        variant="overline"
                        style={{ color: '#d32f2f', fontWeight: 'bold' }}
                      >
                        CUSTOMER IDENTITY
                      </Typography>
                      <Typography
                        variant="h3"
                        style={{
                          fontWeight: 900,
                          color: '#222',
                          marginBottom: '8px',
                          lineHeight: 1.1,
                          textTransform: 'uppercase',
                        }}
                      >
                        {this.props.blacklistAlert.customer.firstName}{' '}
                        {this.props.blacklistAlert.customer.lastName}
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{ color: '#666', marginBottom: '24px' }}
                      >
                        {this.props.blacklistAlert.customer.phone}
                      </Typography>

                      <div
                        style={{
                          backgroundColor: '#fff5f5',
                          borderLeft: '6px solid #d32f2f',
                          padding: '20px',
                          borderRadius: '4px',
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          style={{ color: '#d32f2f', fontWeight: 'bold' }}
                        >
                          RESTRICTION REASON
                        </Typography>
                        <Typography
                          variant="body1"
                          style={{ fontStyle: 'italic', fontSize: '1.1rem' }}
                        >
                          "{this.props.blacklistAlert.customer.blockReason}"
                        </Typography>
                      </div>

                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          marginTop: '32px',
                          backgroundColor: '#000',
                          color: '#fff',
                          padding: '18px',
                          fontWeight: 'bold',
                          fontSize: '1.1rem',
                        }}
                        onClick={() =>
                          this.props.setBlacklistAlert({
                            show: false,
                            customer: null,
                          })
                        }
                      >
                        ACKNOWLEDGE & DISMISS ALERT
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </DialogContent>
            </Dialog>

            {/* --- SHARED ZOOM DIALOG --- */}
            <Dialog
              open={this.state.isImageZoomed}
              onClose={() => this.setState({ isImageZoomed: false })}
              maxWidth="lg"
              PaperProps={{
                style: { backgroundColor: 'transparent', boxShadow: 'none' },
              }}
            >
              <div
                style={{ textAlign: 'center' }}
                onClick={() => this.setState({ isImageZoomed: false })}
              >
                <img
                  src={this.props.blacklistAlert.customer.files?.[0]?.localURL?.replace(
                    /\\/g,
                    '/'
                  )}
                  style={{
                    maxWidth: '95vw',
                    maxHeight: '90vh',
                    border: '2px solid white',
                    borderRadius: '4px',
                  }}
                  alt="Zoomed"
                />
                <p style={{ color: 'white', marginTop: '10px' }}>
                  Click anywhere to close
                </p>
              </div>
            </Dialog>
          </>
        )}

        {this.state.showSelfRegister && (
          <Dialog
            open={this.state.showSelfRegister}
            onClose={() => this.setState({ showSelfRegister: false })}
            maxWidth="xs"
            fullWidth
            PaperProps={{
              style: { borderRadius: 12, padding: '8px' },
            }}
          >
            <DialogTitle
              style={{ textAlign: 'center', fontWeight: 600, color: '#1a237e' }}
            >
              ASSIGN UNREGISTERED TAG
            </DialogTitle>

            <DialogContent>
              <Box
                mb={3}
                p={2}
                style={{
                  backgroundColor: '#f5f7fb',
                  borderRadius: 8,
                  textAlign: 'center',
                }}
              >
                <Typography
                  variant="caption"
                  color="textSecondary"
                  gutterBottom
                >
                  DETECTED NEW TAG
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    letterSpacing: '2px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  {/* SECURITY MASKING: Shows first 2 and last 2 digits only */}
                  {this.state.tempRfid.length > 4
                    ? `${this.state.tempRfid.substring(
                        0,
                        2
                      )}****${this.state.tempRfid.slice(-2)}`
                    : '****'}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginBottom: '16px' }}
              >
                This tag isn't recognized. Select the employee who will be using
                this RFID for access.
              </Typography>

              <Autocomplete
                options={filteredEmployees} // Only show users without tags
                getOptionLabel={(option) =>
                  `${option.firstname || ''} ${option.lastname || ''}`.trim() ||
                  option.username
                }
                onChange={this.handleEmployeeChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Employee"
                    variant="outlined"
                    placeholder="Type name..."
                    fullWidth
                  />
                )}
              />
            </DialogContent>

            <DialogActions style={{ padding: '16px 24px' }}>
              <Button
                onClick={() => this.setState({ showSelfRegister: false })}
                style={{ color: '#757575', textTransform: 'none' }}
              >
                Dismiss
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!this.state.selectedEmployeeId}
                onClick={this.registerTag}
                style={{
                  backgroundColor: '#1a237e',
                  textTransform: 'none',
                  padding: '8px 24px',
                  borderRadius: '6px',
                  fontWeight: 600,
                }}
              >
                Complete Registration
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  }
}

Base.propTypes = {
  socket: PropTypes.object,
  userInfo: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  showingMenuItems: PropTypes.bool,
};

Base.defaultProps = {
  socket: null,
  userInfo: {},
  isAuthenticated: false,
  showingMenuItems: false,
};

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  isAuthenticated: isAuthenticatedSelector(state),
  showingMenuItems: showingMenuItemsSelector(state),
  employees: employeesSelector(state),
  blacklistAlert: blacklistAlertSelector(state),
});

const actionCreators = {
  authLogout,
  triggerRefresh,
  setBlacklistAlert,
  processRFID,
  getEmployees,
  getUsers,
  registerRFID,
  listAvailableCompanies,
  updateUserInfo,
  refreshUserInfo,
  fetchAlerts,
  uploadBonusPhoto,
};

export default withShipment(
  {
    mapStateToProps,
    actionCreators,
  },
  withRouter(Base)
);
